import { PutawayTaskListPage } from '@/features/putaway-task/pages/PutawayTaskListPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/putaway-task/')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["putaway_task.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: PutawayTaskListPage,
})

